import React from "react";
import Layout from "../common/Layout";
import InfoCard, { InfoCardData } from "../components/products/GlassInfoCard";
import productImage1 from "../assets/ps1.png";
import productImage2 from "../assets/ps2.png";
import productImage3 from "../assets/ps3.png";
import productImage4 from "../assets/ps4.png";
import productImage5 from "../assets/ps5.png";
import productImage6 from "../assets/ps6.png";
import PageHeaderWithLoader from "../common/PageHeaderWithLoader";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const productCards: InfoCardData[] = [
  {
    image: productImage1,
    title: "Tempered/ Toughened",
    anchorId: "toughened-glass",
    description: "Heat-treated glass up to 700°C and rapidly cooled, making it 4–5× stronger than standard glass and shatter-safe.",
    characteristics: [
      "High thermal and impact resistance",
      "Breaks into blunt fragments",
      "Available in FT and HS variants",
    ],
    applications: "Building façade, shop fronts, railings, shower cubicles, partitions, doors and windows etc.",
    direction: "imageLeft",
  },
  {
    image: productImage2,
    title: "Heat Strengthened",
    anchorId: "heat-strengthened-glass",
    description: "Twice as strong as annealed glass, heat-strengthened glass offers excellent clarity, enhanced durability minimizing the risk of spontaneous breakage. Fragments remain largely intact even if it cracks.",
    characteristics: [
      "Withstands greater loads",
      "Lower risk of spontaneous breakage",
      "Used where full tempering isn't required",
    ],
    applications: "Curtain walls, spandrels, laminated units, and structural elements with thermal load.",
    direction: "imageRight",
  },
  {
    image: productImage3,
    title: "Heat Soaked",
    anchorId: "heat-soaked-glass",
    description: "Nickel sulfide inclusions in float glass can lead to spontaneous breakage. Our heat soak process rigorously tests tempered glass to ensure maximum reliability and peace of mind post-installation.",
    characteristics: [
      "Reduces risk of spontaneous breakage",
      "Ensures long-term durability",
      "Compliant with global safety standards",
    ],
    applications: "High-rise buildings, facades, point-fixed glazing, skylights or any critical application where safety and performance can't be compromised.",
    direction: "imageLeft",
  },
  {
    image: productImage4,
    title: "Laminated",
    anchorId: "laminated-glass",
    description: "Two or more glass panes bonded by PVB interlayer to form a safety glass that holds together on impact.",
    characteristics: [
      "Shatter-proof and burglar-resistant",
      "Excellent sound and UV insulation",
      "Available in multiple colors and types",
    ],
    applications: "Railings, skylights, floors, curtain walls, partitions, and automotive glazing.",
    direction: "imageRight",
  },
  {
    image: productImage5,
    title: "Insulated",
    anchorId: "insulated-glass",
    description: "Double or triple glass units sealed with air or argon-filled space for superior thermal and acoustic insulation.",
    characteristics: [
      "Reduces heat and sound transmission",
      "Filled with moisture-absorbing desiccant",
    ],
    applications: "Windows, facades, refrigerators, skylights, railways, and airports.",
    direction: "imageLeft",
  },
  {
    image: productImage6,
    title: "Bullet Proof",
    anchorId: "bullet-proof",
    description: "High-security laminated glass designed to resist ballistic impact, combining multiple layers for transparency and protection.",
    characteristics: [
      "Available in different resistance levels",
      "Custom thickness and configuration",
      "Transparent and optically clear",
    ],
    applications: "Banks, embassies, military vehicles, armored buildings, and sensitive facilities.",
    direction: "imageRight",
  },
];

const PerformanceAndSaftey = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location.hash]);

  return (
    <Layout>
      <PageHeaderWithLoader title="Performance & Safety" media={{ type: "image", src: process.env.PUBLIC_URL + "/assets/performanceBackground.webp" }} />
      <InfoCard data={productCards} />
    </Layout>
  );
};

export default PerformanceAndSaftey; 
